// extracted by mini-css-extract-plugin
export default {"expandingMenu":"_d763ff6b","navbarItem":"_c813bc63","navBar":"_a05908b6","userMenu":"_e93777bc","presenceOptIn":"_2f80822b","userMenuContainer":"_f1b1a5db"};